import { ComponentsOverrides, Theme } from "@mui/material";

const cardActionArea = (): ComponentsOverrides<Theme>["MuiCardActionArea"] => {
	return {
		root: {
			// "@media (hover:hover)": {
			"&:hover": {
				"& .MuiCardActionArea-focusHighlight": {
					opacity: 0.12,
				},
			},
			// },
		},
	};
};

export default cardActionArea;
